export class GlobalPairIndicatorSet {
  idGlobalPair: number;
  idIndicatorSet: number;

  constructor(
    idGlobalPair: number,
    idIndicatorSet: number,
  ) {
    this.idGlobalPair = idGlobalPair;
    this.idIndicatorSet = idIndicatorSet;
  }

  static fromRaw(raw: any): GlobalPairIndicatorSet {
    return new GlobalPairIndicatorSet(
      raw.idGlobalPair,
      raw.idIndicatorSet,
    );
  }

  clone(): GlobalPairIndicatorSet {
    return new GlobalPairIndicatorSet(
      this.idGlobalPair,
      this.idIndicatorSet,
    );
  }

  toPayload(): any {
    return {
      idGlobalPair: this.idGlobalPair,
      idIndicatorSet: this.idIndicatorSet,
    };
  }
} 